import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useSEO } from "@/hooks/useSEO";
import { Loader } from "@/components/shared/Loader";

const slugToType = { privacy: "privacy", terms: "terms", "risk-disclosure": "risk", disclaimer: "disclaimer" };
const titles = { privacy: "Privacy Policy", terms: "Terms & Conditions", risk: "Risk Disclosure", disclaimer: "Disclaimer" };

export default function Legal() {
  const { type: param } = useParams();
  const location = useLocation();
  const slug = param || location.pathname.replace("/", "");
  const type = slugToType[slug] || param || "privacy";
  const [doc, setDoc] = useState(null);
  useSEO(titles[type] || "Legal");

  useEffect(() => { setDoc(null); api.get(`/legal/${type}`).then((r) => setDoc(r.data)).catch(() => setDoc({ title: titles[type], content: "" })); }, [type]);

  if (!doc) return <Loader full={false} />;
  const fmt = (d) => (d ? new Date(d).toLocaleDateString() : null);
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-white">{doc.title || titles[type]}</h1>
      <div className="mt-2 flex flex-wrap gap-x-4 text-xs font-mono text-slate-500">
        {doc.version ? <span>Version {doc.version}</span> : null}
        {fmt(doc.effective_date) && <span>Effective {fmt(doc.effective_date)}</span>}
        {fmt(doc.updated_at) && <span>Last updated {fmt(doc.updated_at)}</span>}
      </div>
      <div className="mt-8 text-slate-300 leading-relaxed whitespace-pre-wrap" data-testid="legal-content">{doc.content || "Content will be provided soon."}</div>
    </div>
  );
}
